import * as actions from './employeeLoan/actions'
import * as mutations from './employeeLoan/mutations'
import * as getters from './employeeLoan/getters'

import { dataProps } from './employeeLoan/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.date_of_loan',
        sort_direction: 1, 
        search_term: '', 
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/employeeLoan.js